import React from "react";
import ReactDOM from "react-dom/client";
import {createBrowserRouter, Navigate, RouterProvider} from "react-router-dom";
import "./index.css";
import App from "./App";
import Home from "./pages/Home";
import {PrimeReactProvider} from "primereact/api";
import "primereact/resources/themes/md-light-indigo/theme.css";
import "primeicons/primeicons.css";
import TestFrame from "./pages/TestFrame";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/map",
        element: <Home />,
      },
      {
        path: "/kiosk",
        element: <Home kiosk />,
      },
      {
        path: "/embedded",
        element: <TestFrame />,
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/map" />,
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <PrimeReactProvider>
      <RouterProvider router={router} />
    </PrimeReactProvider>
  </React.StrictMode>
);
